export enum WEB_ROUTES {
  SIDEMENU_DASHBOARD = 'dashboard',
  SIDEMENU_VENDOR = 'vendor',
  SIDEMENU_CLIENT = 'client',
  SIDEMENU_INVOICE = 'invoice',
  SIDEMENU_DOCUMENTS = 'documents',
  SIDEMENU_REPORTS = 'reports',
  SIDEMENU_USER = 'user',
  SIDEMENU_SETTINGS = 'settings',

  LOGIN = '/authentication',

  FORM = 'form',
  VIEW = 'view',
  HISTORY = 'history',
  GRID = 'grid',
  ATTACH = 'attach-document',
  CLIENT = '/client',
  VENDOR = '/vendor',
  USER = '/user',
  FORCE_FULLY_ADD_APPROVER_USER = 'forcefull-add-approver',
  FORCE_FULLY_VENDOR = 'forcefull-add-vendor',
  MAILBOX_FORM = 'mailboxform',
  INVOICE = '/invoice',
  DOCUMENTS = '/documents',
  REPORTS = '/reports',
  DETAILS = 'details',
  MESSAGES = 'messages',
  MESSAGE_VIEW = 'message-view',
  VIEW_DOCUMENT = 'view-document',
  USER_EMERGENCY_CONTACT = 'emergency-contact',
  USER_DOCUMENT = 'document',

  DOCUMENT_UNKNOWN_TYPE = '/documents/unknown-document',

  DASHBOARD = '/dashboard',
  MONTHLY_HISTORY = 'monthly-history',
  MONTHLY_INVOICE = 'monthly-invoice',
  DUPLICATE_DOCUMENTS = 'duplicate-documents',
  DASHBOARD_MONTHLY_HISTORY = '/dashboard/monthly-history',
  DASHBOARD_MONTHLY_INVOICE = '/dashboard/monthly-invoice',
  DASHBOARD_DUPLICATE_DOCUMENTS = '/dashboard/duplicate-documents',

  FORCEFULLY_CHANGE_PASSWORD = '/authentication/forcefully-change-password',
  CHANGE_PASSWORD = '/authentication/change-password',
  FORGOT_PASSWORD = '/authentication/forgot-password',

  SEND_OTP = '/authentication/send-otp',

  CLIENT_FORM = '/client/form',
  CLIENT_HISTORY = '/client/history',

  VENDOR_FORM = '/vendor/form',
  VENDOR_ARCHIVE = '/vendor/archive',
  VENDOR_HISTORY = '/vendor/history',
  VENDOR_GRID = '/vendor/grid',
  USER_GRID = '/user/grid',
  USER_HISTORY = '/user/history',
  USER_FORM = '/user/form',
  USER_EMERGENCY_CONTACT_FORM = '/user/emergency-contact/form',
  USER_DOCUMENT_FORM = '/user/document/form',

  COMPANY_INFO_FORM = 'company-info-form',

  INVOICE_DETAILS = '/invoice/details',
  INVOICE_VIEW_DOCUMENT = '/invoice/view-document',
  INVOICE_MESSAGES = '/invoice/messages',
  INVOICE_MESSAGE_VIEW = '/invoice/message-view',
  INVOICE_HISTORY = '/invoice/history',
  INVOICE_ATTACH_DOCUMENT = '/invoice/attach-document',


  VIEW_REPORT = 'reports/view',

  MAILBOX_SETTING = '/settings/mailbox',
  MAILBOX_FOR_SETTING = '/settings/mailbox-form',
  EMPLOYEE_SETTING = '/settings/employeesettings',
  ROLE_SETTING = '/settings/rolesettings',
  ALERT_SETTING = '/settings/alerts',
  SMTP_SETTING = '/settings/smtp',
  INTEGRATION_SETTING = '/settings/integration',
  QBO_INTEGRATION_SETTING = '/settings/qbo-integration',
  QBD_INTEGRATION_SETTING = '/settings/qbd-integration',
  USAGE_SETTING = '/settings/usage',
  OTHER_SETTING = '/settings/othersettings',
  SECURITY_SETTING = '/settings/security',
  COSTCODE_SETTING = '/settings/costcode',
  DOCUMENT_VIEW_SETTING = '/settings/documentview',
  COMPANY_INFO_FORM_SETTING = '/settings/company-info-form',
  USAGE_INVOICE_LIST = '/settings/usage-invoice-list',
  USAGE_DUPLICATE_INVOICE_LIST = '/settings/usage-duplicate-invoice-list',
  USAGE_TOTAL_INVOICE_LIST = '/settings/usage-total-invoice-list',
  TICKET_LIST = '/ticket-list',

  HELP_MENU = '/common/help-menu',

}

export enum SUPERADMIN_ROUTES {
  LOGIN = '/superadmin/authentication',
  CHANGE_PASSWORD = 'superadmin/authentication/change-password',
  FORCEFULLY_CHANGE_PASSWORD = 'superadmin/authentication/forcefully-change-password',
  FORGOT_PASSWORD = 'superadmin/authentication/forgot-password',
  SEND_OTP = 'superadmin/authentication/send-otp',

  SIDEMENU_DASHBOARD = 'dashboard',
  SIDEMENU_SUPERADMIN = 'superadmins',
  SIDEMENU_DISTRIBUTOR = 'distributors',
  SIDEMENU_AGENT = 'agents',
  SIDEMENU_CLIENTS = 'clients',
  SIDEMENU_SETTINGS = 'settings',
  SIDEMENU_TICKET = 'ticket',

  DASHBOARD = '/superadmin/dashboard',
  SUPERADMIN = '/superadmin/superadmins',
  DISTRIBUTOR = '/superadmin/distributors',
  AGENT = '/superadmin/agents',
  CLIENTS = '/superadmin/clients',
  SETTINGS = '/superadmin/settings',
  CLIENTS_USAGE = 'usage',
  CLIENTS_USAGE_INVOICE_LIST = 'usage-invoice-list',
  CLIENTS_USAGE_DUPLICATE_INVOICE_LIST = 'usage-duplicate-invoice-list',
  CLIENTS_USAGE_TOTAL_INVOICE_LIST = 'usage-total-invoice-list',
  CLIENTS_SMTP = 'smtp',
  CLIENTS_MAILBOX = 'mailbox',

  FORM = 'form',
  HISTORY = 'history',
  LOGIN_HISTORY = 'login-history',

  SUPERADMIN_FORM = '/superadmin/superadmins/form',
  DISTRIBUTOR_FORM = '/superadmin/distributors/form',
  AGENT_FORM = '/superadmin/agents/form',
  CLIENT_FORM = '/superadmin/clients/form',
  SUPERADMIN_HISTORY = '/superadmin/superadmins/history',
  SUPERADMIN_LOGIN_HISTORY = '/superadmin/superadmins/login-history',
  DISTRIBUTOR_HISTORY = '/superadmin/distributors/history',
  AGENT_HISTORY = '/superadmin/agents/history',
  SMTP_SETTING = '/superadmin/settings/smtp',
  SMARTACCUPAY_OTHER_SETTING = 'other-settings',
  SMARTACCUPAY_GIF_SETTING = 'gif',
  SMARTACCUPAY_ROLE_SETTING = 'role',
  UPDATE_ALERT_SETTINGS_SMARTACCUPAY = 'update-alert',
  PLAN = 'plan',
  COUPON = 'Coupon',
  PLAN_FORM = 'plan-form',
  COUPON_FORM = 'Coupon-form',
  PLAN_SETTING = '/superadmin/settings/plan',
  COUPON_LIST = '/superadmin/settings/Coupon',
  COUPON_ADD_FORM = '/superadmin/settings/Coupon-form',
  CLIENTS_PAYMENT_HISTORY = 'payment_history',
  //restriction sereen 
  PAYMENT_RESTRICTION_SCREEN = 'superadmin/authentication/payment-restriction',
  UPDATE_PAYMENT_RESTRICTION_SCREEN = 'superadmin/authentication/subscription-plan-screen',
    TICKET_FORM = '/superadmin/ticket/form',
  TICKET = '/superadmin/ticket',
}